import React from "react";
import PageContainer from "../components/PageContainer";
import CallToActionOne from "../components/call-to-action-one";
import Footer from "../components/footer";
import StudioReleases from "../components/featuredAlbums";
import SoundPacks from "../components/artistSoundPacks";
import ServiceTwo from "../components/service-two";
import AboutTwo from "../components/about-two";
import HeaderOne from "../components/header-one";
import MenuContextProvider from "../context/menu-context";
import SliderOne from "../components/slider-one";
import VideoSection from "../components/videoSection";
import welcomeToTheHalfHouse from "../assets/images/releases/welcomeToTheHalfHouse.png";
import girls from "../assets/images/releases/girls.png";
import lostInTheNight from "../assets/images/releases/lostInTheNight.png";
import fuckTheRich from "../assets/images/releases/fuckTheRich.png";
import noFear from "../assets/images/releases/noFear.png";
import findMyWay from "../assets/images/releases/findMyWay.png";
import soundPack1 from "../assets/images/releases/soundPack1.png";
import soundPack2 from "../assets/images/releases/soundPack2.png";
import soundPack3 from "../assets/images/releases/soundPack3.png";
import soundPack4 from "../assets/images/releases/soundPack4.png";
import soundPack5 from "../assets/images/releases/soundPack5.png";
import soundPack6 from "../assets/images/releases/soundPack6.png";
import videoSliderGif1 from "../assets/gifs/findMyWayCut.gif";
import videoSliderGif3 from "../assets/gifs/pod3.gif";

class LandingPage extends React.Component {
  state = {
    artistNameLink: "",
    artistReleases: [
      {
        title: "Welcome to half house",
        image: welcomeToTheHalfHouse,
        url: "https://open.spotify.com/album/4u4VnzdDPXlSsJ63JJiY3o?si=T_5vuEVmSama2pICeG7D5w"
      },
      {
        title: "Girls!",
        image: girls,
        url: "https://open.spotify.com/album/34yQQ3oVfiI0bsMgKBHOJt?si=T-CIdG33Sbu87rHkuWz_Ug"
      },
      {
        title: "Lost In The Night",
        image: lostInTheNight,
        url: "https://open.spotify.com/album/4u4VnzdDPXlSsJ63JJiY3o?si=T_5vuEVmSama2pICeG7D5w"
      },
      {
        title: "F**k The Rich",
        image:fuckTheRich,
        url: "https://open.spotify.com/album/4u4VnzdDPXlSsJ63JJiY3o?si=T_5vuEVmSama2pICeG7D5w"
      },
      {
        title: "No Fear",
        image: noFear,
        url: "https://open.spotify.com/track/26qLIxMeCcuLgRl0xmo85x?si=6074dcbc5e804dee"
      },
      {
        title: "Find My Way",
        image: findMyWay,
        url: "https://open.spotify.com/album/1kZLsXNUk9QFmprJnsHa1t?si=BMBcT1AZSEKLWZrmG4AeXQ"
      }
    ],
    SoundPackData: [
      {
        title: "Sound Pack 1",
        categories: ["Hip-Hop, ", "Lo-Fi, ", "Pop"],
        image: soundPack1,
        url: "/soundpacks"
      },
      {
        title: "Sound Pack 2",
        categories: ["Hip-Hop, ", "Lo-Fi, ", "Pop"],
        image: soundPack2,
        url: "/soundpacks"
      },
      {
        title: "Sound Pack 3",
        categories: ["Hip-Hop, ", "Lo-Fi, ", "Pop"],
        image: soundPack3,
        url: "/soundpacks"
      },
      {
        title: "Sound Pack 4",
        categories: ["Hip-Hop, ", "Lo-Fi, ", "Pop"],
        image: soundPack4,
        url: "/soundpacks"
      },
      {
        title: "Sound Pack 5",
        categories: ["Hip-Hop, ", "Lo-Fi, ", "Pop"],
        image: soundPack5,
        url: "/soundpacks"
      },
      {
        title: "Sound Pack 6",
        categories: ["Hip-Hop, ", "Lo-Fi, ", "Pop"],
        image: soundPack6,
        url: "/soundpacks"
      }
    ],
    VideoOneData: {
      sectionContent: {
        title: "Find My Way",
        subTitle: "Official Music Video",
        text:
            ""
      },
      video: {
        title: "",
        ID: "l1K7yeOyruQ",
        image: videoSliderGif1
      }
    },
    VideoTwoData: {
      sectionContent: {
        title: "Pod Nem: Deathcon 3?! What Kanye??",
        subTitle: "Pod nem | SZN 2 EP 2",
        text: ""
      },
      video: {
        title: "",
        ID: "YLS8vnHLHWg",
        image: videoSliderGif3
      }
    }
  }
  render() {
    return (
        <MenuContextProvider>
          <PageContainer >
            <HeaderOne/>
            <SliderOne/>
            <ServiceTwo/>
            <AboutTwo/>
            <VideoSection data={this.state.VideoOneData}/>
            <StudioReleases data={this.state}/>
            <VideoSection data={this.state.VideoTwoData}/>
            <SoundPacks data={this.state}/>
            <CallToActionOne />
            <Footer/>
          </PageContainer>
        </MenuContextProvider>
    );
  }
}

export default LandingPage;
